import {
  FaBuilding,
  FaShieldAlt,
  FaDollarSign,
  FaUsers,
  FaHome,
} from "react-icons/fa";
import { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaCheck, FaArrowRight } from "react-icons/fa";
// import { services } from "./servicesData";
import "./whatwedo.css";

export const services = [
  {
    id: 1,
    title: "Establishment & Setup",
    icon: <FaBuilding />,
    heading: "GCC Establishment & Business Setup",
    description:
      "Launching a Global Capability Centre requires careful planning, regulatory compliance and operational readiness.",

    features: [
      "Business Structure Advisory",
      "Entity Formation",
      "Registration & Licensing",
      "Regulatory Approvals",
      "Banking Setup",
      "Tax Registration",
      "Operational Launch Support",
    ],
  },

  {
    id: 2,
    title: "Legal & Compliance",
    icon: <FaShieldAlt />    ,
    heading: "Legal & Compliance Management",
    description:
      "Maintain compliance with IFSC regulations while minimizing operational risk.",

    features: [
      "IFSCA Compliance",
      "FEMA Advisory",
      "Corporate Secretarial",
      "Governance Framework",
      "Regulatory Filings",
      "Risk Management",
      "Data Privacy",
      "Contract Management",
    ],
  },

  {
    id: 3,
    title: "Finance & Treasury",
    icon: <FaDollarSign />,
    heading: "Finance & Treasury Solutions",
    description: "Integrated treasury, banking and accounting solutions.",

    features: [
      "Multi Currency Banking",
      "Treasury Management",
      "Payroll",
      "GST Compliance",
      "Financial Reporting",
      "Budget Planning",
      "Tax Optimization",
    ],
  },

  {
    id: 4,
    title: "Talent & HR Solutions",
    icon: <FaUsers />,
    heading: "Talent Acquisition & HR Solutions",
    description: "Build high-performing teams with strategic recruitment.",

    features: [
      "Leadership Hiring",
      "Technology Recruitment",
      "Finance Hiring",
      "Workforce Planning",
      "HR Policy",
      "Compensation",
      "Employee Onboarding",
    ],
  },

  {
    id: 5,
    title: "Relocation & Lifestyle",
    icon: <FaHome />,
    heading: "Executive Relocation & Lifestyle Support",
    description: "End-to-end relocation support for global executives.",

    features: [
      "Housing",
      "School Admissions",
      "Visa",
      "Healthcare",
      "Travel",
      "Lifestyle Concierge",
    ],
  },
];

const Whatwedo = () => {
  const [active, setActive] = useState(services[0]);
  return (
    <div>
      <section className="pillar-section">
        <Container>
          <h4 className="pillar-title  text-center">What We Do</h4>
          <h1 className="pillar-heading text-center">
            Comprehensive Solutions for Your GCC in GIFT City
          </h1>
          <p className="pillar-description text-center mb-5">
            We provide end-to-end support for establishing, operating and
            scaling your Global Capability Centre in GIFT City. Our services
            cover every aspect of the journey, from business setup and
            regulatory compliance to talent acquisition, finance management and
            executive relocation.
          </p>

          <Row>
            <Col lg={3}>
              <div className="service-nav">
                {services.map((item) => (
                  <button
                    key={item.id}
                    onClick={() => setActive(item)}
                    className={active.id === item.id ? "active" : ""}
                  >
                    <span>{item.title}</span>

                    {active.id === item.id && <FaArrowRight />}
                  </button>
                ))}
              </div>
            </Col>

            <Col lg={9}>
              <div className="service-card">
                <div className="service-header">
                  <div className="icon-box">{active.icon}</div>

                  <h2>{active.heading}</h2>
                </div>

                <p>{active.description}</p>

                <Row>
                  {active.features.map((item, index) => (
                    <Col md={6} key={index}>
                      <div className="feature-box">
                        <FaCheck />

                        <span>{item}</span>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Whatwedo;
